import { z } from "zod"

import {
  correlationIdSchema,
  entityIdSchema,
  legalEntityIdSchema,
} from "./identifiers.js"

const request = z.object({
  requestVersion: z.literal(1),
  correlationId: correlationIdSchema,
  idempotencyKey: z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/),
  expectedVersion: z.number().int().positive(),
}).strict()

export const paymentProviderV1Schema = z.literal("stripe")
export const paymentProviderModeV1Schema = z.literal("test")
export const paymentProviderAccountIdV1Schema = z.string().regex(/^acct_[A-Za-z0-9]{8,64}$/)
export const paymentProviderCustomerIdV1Schema = z.string().regex(/^cus_[A-Za-z0-9]{8,64}$/)

export const paymentProviderAccountMapV1Schema = request.extend({
  mappingId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  provider: paymentProviderV1Schema,
  providerAccountId: paymentProviderAccountIdV1Schema,
}).strict()

export const billingProfilePaymentCustomerEnsureV1Schema = request.extend({
  customerMappingId: entityIdSchema,
  billingProfileId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  paymentAccountMappingId: entityIdSchema,
}).strict()

export const paymentProviderAccountMappingV1Schema = z.object({
  mappingId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  provider: paymentProviderV1Schema,
  providerMode: paymentProviderModeV1Schema,
  providerAccountId: paymentProviderAccountIdV1Schema,
  chargesEnabled: z.boolean(),
  payoutsEnabled: z.boolean(),
  cardPaymentsCapability: z.enum(["active", "inactive", "pending", "unrequested"]),
  country: z.string().regex(/^[A-Z]{2}$/),
  defaultCurrency: z.string().regex(/^[a-z]{3}$/),
  version: z.number().int().positive(),
}).strict()

export const billingProfilePaymentCustomerMappingV1Schema = z.object({
  customerMappingId: entityIdSchema,
  billingProfileId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  paymentAccountMappingId: entityIdSchema,
  provider: paymentProviderV1Schema,
  providerAccountId: paymentProviderAccountIdV1Schema,
  providerCustomerId: paymentProviderCustomerIdV1Schema,
  version: z.number().int().positive(),
}).strict()

export type PaymentProviderAccountMapV1 = z.infer<
  typeof paymentProviderAccountMapV1Schema
>
export type BillingProfilePaymentCustomerEnsureV1 = z.infer<
  typeof billingProfilePaymentCustomerEnsureV1Schema
>
export type PaymentProviderAccountMappingV1 = z.infer<
  typeof paymentProviderAccountMappingV1Schema
>
export type BillingProfilePaymentCustomerMappingV1 = z.infer<
  typeof billingProfilePaymentCustomerMappingV1Schema
>
